import { StyledEngineProvider } from '@mui/material/styles';
import { jssPreset } from '@mui/styles';
import { create } from 'jss';

const ConfigureJSS = (props) => {
	// Configure JSS
	const plugins = [...jssPreset().plugins];

	return <StyledEngineProvider jss={create({ plugins })}>{props.children}</StyledEngineProvider>;
};

export default ConfigureJSS;
